import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import {tap} from 'rxjs/internal/operators';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AutenticacionService } from './autenticacion.service';
import { MensajeService } from './mensaje.service';
import { SpinnerService } from 'src/app/spinner.service';


@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

  constructor(private auth: AutenticacionService,
              private router : Router,
              private msgserv : MensajeService,
              private spin : SpinnerService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    let user = this.auth.currentUserValue;
    this.spin.spin$.next(true);
    
    if (user && user.token){
      req = req.clone({
        setHeaders: {
          Authorization: `token ${user.token}`
        }
      })
    }
    return next.handle(req)
               .pipe(tap(evt =>{
                    }, 
                    err =>{
                      if(err.status == 403 || err.status == 401){//sin permiso
                          
                          let msg = '';                          
                          if ( err.error.msg === 'Token Invalido.'){

                              msg =  "Su sesión ha expirado";
                              this.msgserv.ver_mensaje(msg, '', this.msgserv.TIPO_ERROR )
                                  .afterClosed()
                                  .subscribe(
                                    ()=>{
                                      this.auth.eliminar_sesion();
                                      this.router.navigate([environment.login])
                                                  .then(()=>{
                                                    window.location.reload();
                                                  });
                                    }
                                  );
                          }

                    
                        }else{
                          if (err.error && err.error.msg){

                            this.msgserv.ver_mensaje(err.error.msg, 
                                                    'Ocurrieron los siguientes Errores.',
                                                    this.msgserv.TIPO_ERROR)
                                          .afterClosed()
                                          .subscribe(()=>{
                                            if(err.error.code == 16){
                                              this.auth.eliminar_sesion();
                                              this.router.navigate([environment.login])
                                                  .then(()=>{
                                                    window.location.reload();
                                                  });
                                            }
                                          });
                          }else{
                            this.msgserv.ver_mensaje(JSON.stringify(err), 
                                                    'Ocurrieron los siguientes Errores.',
                                                    this.msgserv.TIPO_ERROR);
                          }
                        }
                        this.spin.spin$.next(false);
                      })
            );
  }

  

}
